import { useEffect, useState } from "react";
import { Keyboard, ScrollView, StyleSheet, TouchableWithoutFeedback } from "react-native";
import { KeyboardAwareScrollView } from "react-native-keyboard-aware-scroll-view";
import { Masks } from "react-native-mask-input";
import Icon from "react-native-vector-icons/MaterialCommunityIcons";
import IconButton from "../../components/ButtonIcon";
import CaixaTextoInputIcone from "../../components/TextBoxIcon";
import LicensePlate from "../../components/LicensePlate";
import PageTitle from "../../components/PageTitle";
import { AddVehicle, GetPlacaDetran } from "../../services/Api/vehicles";
import * as Colors from "../../styles/colors";
import ColorPickerModal from "./components/ColorPickerModal";
import BetterAlert from "../../components/BetterAlert"
import ClientVehicle from "../../models/clientVehicle"
import { IS_WEB } from "@services/Config";

export default function VehiclesForm({ navigation, route }) {

  const [modalVisible, setModalVisible] = useState(false);
  const [showAlert, setShowAlert] = useState({})

  const [licensePlate, setLicensePlate] = useState("");
  const [validLicensePlate, setValidLicensePlate] = useState({
    isValid: true,
    invalidMessage: "Placa inválida",
  });

  const [brand, setBrand] = useState("");
  const [validBrand, setValidBrand] = useState({
    isValid: true,
    invalidMessage: "Marca inválida",
  });

  const [model, setModel] = useState("");
  const [validModel, setValidModel] = useState({
    isValid: true,
    invalidMessage: "Modelo inválido",
  });

  const [color, setColor] = useState("");
  const [validColor, setValidColor] = useState({
    isValid: true,
    invalidMessage: "Placa Inválida",
  });

  const params = route.params

  useEffect(() => {
    if (licensePlate.replace("-", "").length == 7) {
      GetPlacaDetran(licensePlate.replace("-", ""))
        .then((value) => {
          setBrand(value.MARCA)
          setModel(value.MODELO)
          setColor(value.COR.toUpperCase())
        })
    }
  }, [licensePlate])

  const SaveVehicle = () => {
    let valid = true
    if (licensePlate.replace("-", "").length != 7) {
      valid = false
      setValidLicensePlate({ ...validLicensePlate, isValid: false })
    } else {
      setValidLicensePlate({ ...validLicensePlate, isValid: true })
    }

    if (brand.length == 0) {
      valid = false
      setValidBrand({ ...validBrand, isValid: false })
    } else {
      setValidBrand({ ...validBrand, isValid: true })
    }

    if (model.length == 0) {
      valid = false
      setValidModel({ ...validModel, isValid: false })
    } else {
      setValidModel({ ...validModel, isValid: true })
    }

    if (color.length == 0) {
      valid = false
      setValidColor({ ...validColor, isValid: false })
    } else {
      setValidColor({ ...validColor, isValid: true })
    }

    if (valid) {
      //Chamada da Api para salvar o veiculo
      let clientVehicle = new ClientVehicle(params.idClient, params.idContract, licensePlate.replace("-", ""), "", "", color, model)
      AddVehicle(clientVehicle).then((value) => {
        setShowAlert({
          type: "success",
          title: "Veículo cadastrado",
          // message: value.message,
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ show: false });
            navigation.goBack()
          },
          showConfirmButton: true,
        });
      }).catch((value) => {
        setShowAlert({
          type: "alert",
          title: "Oops",
          message: value.message ?? "Ocorreu um erro ao tentar salvar o veículo",
          show: true,
          confirmText: "OK",
          pressConfirm: () => {
            setShowAlert({ show: false });
          },
          showConfirmButton: true,
        });
      })
    }
  }

  return (
    <PageTitle title={"Adicionar Veículos"} navigation={navigation}>
      <KeyboardAwareScrollView
        style={{ flex: 1, backgroundColor: Colors.WHITE }}
        keyboardShouldPersistTaps={"always"}
      >
        <TouchableWithoutFeedback onPress={!IS_WEB ? Keyboard.dismiss : null}>
          <ScrollView keyboardShouldPersistTaps={"always"}>
            <LicensePlate plate={licensePlate} />
            <CaixaTextoInputIcone
              placeholderInput={"Placa do veículo"}
              onChangeTextInput={(licensePlate) => setLicensePlate(licensePlate)}
              value={licensePlate}
              maskInput={Masks.BRL_CAR_PLATE}
              autoCapitalize={"characters"}
              styleBox={{ width: "100%", marginTop: 16 }}
              {...validLicensePlate}
            />

            <CaixaTextoInputIcone
              placeholderInput={"Marca do veículo"}
              onChangeTextInput={(brand) => setBrand(brand)}
              value={brand}
              autoCapitalize={"characters"}
              styleBox={{ width: "100%" }}
              {...validBrand}
            />

            <CaixaTextoInputIcone
              placeholderInput={"Modelo"}
              onChangeTextInput={(model) => setModel(model)}
              value={model}
              autoCapitalize={"characters"}
              styleBox={{ width: "100%" }}
              {...validModel}
            />

            <CaixaTextoInputIcone
              placeholderInput={"Cor"}
              onChangeTextInput={(color) => setColor(color)}
              value={color}
              autoCapitalize={"characters"}
              styleBox={{ width: "100%" }}
              {...validColor}
              iconAction={
                <Icon
                  style={styles.iconAction}
                  name={"format-color-fill"}
                  size={24}
                  color={Colors.BLACK}
                  onPress={() => setModalVisible(!modalVisible)}
                />
              }
            />
            <ColorPickerModal
              setModalVisible={setModalVisible}
              modalVisible={modalVisible}
              setColor={setColor}
            />
            <IconButton
              iconName={"check-bold"}
              textoBotao={"Salvar"}
              estilo={{
                backgroundColor: Colors.SUCCESS,
                width: "100%",
              }}
              onPress={() => SaveVehicle()}
            />
            <BetterAlert {...showAlert} />
          </ScrollView>
        </TouchableWithoutFeedback>
      </KeyboardAwareScrollView>
    </PageTitle>
  );
}

const styles = StyleSheet.create({
  iconAction: {
    position: "absolute",
    right: 5,
  },
});
